import {
  REQUEST_RISK_PROFILER_RESULTS,
  RECEIVE_RISK_PROFILER_RESULTS,
  ERROR_RETRIEVING_RISK_PROFILER_RESULTS,
} from "typeConstants";

import { riskProfiler as initialState } from "reducers/initialState.tsx";

const riskProfiler = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_RISK_PROFILER_RESULTS:
      return {
        ...state,
        fetchingRiskProfilerResults: true,
        riskProfilerResults: {},
      };
    case RECEIVE_RISK_PROFILER_RESULTS:
      return {
        ...state,
        fetchingRiskProfilerResults: false,
        riskProfilerResults: action.payload,
      };
    case ERROR_RETRIEVING_RISK_PROFILER_RESULTS:
      return {
        ...state,
        fetchingRiskProfilerResults: false,
        riskProfilerResults: {}
      };
    default:
      return state;
  }
};

export default riskProfiler;